import { components } from 'react-select/dist/react-select.cjs.prod';
import AuthorizedComponent from '../components/hoc/AuthorizedComponent';
import {
  AddOffer,
  AddTerminal,
  ContactUs,
  Dashboard,
  ViewEarnings,
  ViewOffers,
  ViewPayments,
  ViewTerminals,
  AddPayment,
  AddMerchant,
  Home,
  ViewMerchants,
  AddMerchantGroups,
  ViewMerchantGroups,
  ViewPurchases,
  PendingPurchases,
  ViewVouchers,
  GreetlyVouchers,
  AddProducts,
  OTPLogs,
  IPLogs,
  DenominationsSummary,
  UploadDenominations,
  ViewClientOrders,
  PlaceClientOrder,
  ViewOrders,
  ViewVoucherThemes,
  ViewProducts,
  AddVoucherThemes,
  AddProductCategory,
  ViewProductCategory,
  CreateUser,
} from '../screens';
import PendingCreditTopUp from '../screens/PendingCreditTopUp/PendingCreditTopUp';
import UserDetails from '../screens/userDetails/userDetails.screen';
import { EarningsRoles } from '../types/RedemptionEnums';
import ClientDashboard from '../screens/dashboard/ClientDashboard';
import ViewClientRedemptions from '../screens/ViewClientRedemptions/ViewClientRedemptions';
import ClientRedemptionMerchantSummary from '../screens/ClientRedemptionMerchantSummary/ClientRedemptionMerchantSummary';

export const acceptOfferRole = ['ROLE_THYAGA_ADMINISTRATOR'];
const acceptTerminalsRole = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
  'ROLE_THYAGA_CUSTOMER_CARE',
];
const acceptEarningsRole = Object.values(EarningsRoles);

const acceptAddMerchantRole = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_CUSTOMER_CARE',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
  'ROLE_THYAGA_ACCOUNTANT',
];

const acceptPaymentsRole = ['ROLE_MERCHANT_ADMINISTRATOR'];
const acceptAddPaymentRole = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_ACCOUNTANT',
   'ROLE_THYAGA_MERCHANT_CONTROLLER',
];

const acceptViewPurchases = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_CUSTOMER_CARE',
  'ROLE_THYAGA_ACCOUNTANT',
];
const acceptUserDetails = ['ROLE_THYAGA_ADMINISTRATOR'];
const acceptCreateUser = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
];
const acceptMerchantControllerUsers = ['ROLE_THYAGA_MERCHANT_CONTROLLER'];
const acceptViewVouchers = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_CUSTOMER_CARE',
  'ROLE_THYAGA_ACCOUNTANT',
];
const acceptUserLogs = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_CUSTOMER_CARE',
];
const acceptMerchantVouchers = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
];
const acceptClientManagement = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
  'ROLE_THYAGA_SALES_AGENT',
  'ROLE_THYAGA_CUSTOMER_CARE',
];

const acceptClientOrderPlace = [
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_MERCHANT_CONTROLLER',
  'ROLE_THYAGA_SALES_AGENT',
  'ROLE_THYAGA_CUSTOMER_CARE',
];

const acceptMarketing = [
  'ROLE_THYAGA_MARKETING',
  'ROLE_THYAGA_ADMINISTRATOR',
  'ROLE_THYAGA_CUSTOMER_CARE',
  'ROLE_THYAGA_ACCOUNTANT',
];

const acceptCLientInfo = [
  'ROLE_REWARD_CLIENT_USER'
];

const routes = [
  {
    name: 'Home',
    path: '/',
    component: Home,
  },
  {
    name: 'Users',
    path: '/users',
    acceptUserRole: acceptUserDetails,
    children: [
      {
        name: 'Create Admin User',
        path: '/create-user',
        component: AuthorizedComponent(CreateUser, acceptCreateUser),
      },
      {
        name: 'User Details',
        path: '/user-details',
        component: AuthorizedComponent(UserDetails, acceptUserDetails),
      },
    ],
  },
  {
    name: 'Users',
    path: '/users',
    acceptUserRole: acceptMerchantControllerUsers,
    children: [
      {
        name: 'Create Admin User',
        path: '/create-user',
        component: AuthorizedComponent(CreateUser, acceptCreateUser),
      },
    ],
  },
  {
    name: 'Security Logs',
    path: '/security',
    acceptUserRole: acceptUserLogs,
    children: [
      {
        name: 'IP Logs',
        path: '/ip-logs',
        component: AuthorizedComponent(IPLogs, acceptUserLogs),
      },
      {
        name: 'OTP Logs',
        path: '/otp-logs',
        component: AuthorizedComponent(OTPLogs, acceptUserLogs),
      },
    ],
  },
  {
    name: 'Offers',
    path: '/offers',
    acceptUserRole: acceptOfferRole,
    children: [
      {
        name: 'View Offers',
        path: '/',
        component: AuthorizedComponent(ViewOffers, acceptOfferRole),
      },
      {
        name: 'Add Offer',
        path: '/add-offer',
        component: AuthorizedComponent(AddOffer, acceptOfferRole),
      },
    ],
  },
  {
    name: 'Terminals',
    path: '/terminals',
    acceptUserRole: acceptTerminalsRole,
    children: [
      {
        name: 'View Terminals',
        path: '',
        component: AuthorizedComponent(ViewTerminals, acceptTerminalsRole),
      },
      {
        name: 'Add Terminal',
        path: '/add-terminal',
        component: AuthorizedComponent(AddTerminal, acceptTerminalsRole),
      },
    ],
  },
  {
    name: 'Earnings',
    path: '/earnings',
    acceptUserRole: acceptEarningsRole,
    children: [
      {
        name: 'View Redemptions',
        path: '',
        component: AuthorizedComponent(ViewEarnings, acceptEarningsRole),
      },
    ],
  },
  {
    name: 'Payments',
    path: '/payments',
    acceptUserRole: acceptPaymentsRole,
    children: [
      {
        name: 'View Payments',
        path: '',
        component: AuthorizedComponent(ViewPayments, acceptPaymentsRole),
      },
    ],
  },
  {
    name: 'Payments',
    path: '/payments',
    acceptUserRole: acceptAddPaymentRole,
    children: [
      {
        name: 'View Payments',
        path: '/payments',
        component: AuthorizedComponent(ViewPayments, acceptAddPaymentRole),
      },
      {
        name: 'Add Payment',
        path: '/add-payment',
        component: AuthorizedComponent(AddPayment, acceptAddPaymentRole),
      },
    ],
  },
  {
    name: 'Merchants',
    path: '/merchants',
    acceptUserRole: acceptAddMerchantRole,
    children: [
      {
        name: 'View Merchants',
        path: '/view-Merchants',
        component: AuthorizedComponent(ViewMerchants, acceptAddMerchantRole),
      },
      {
        name: 'Add Merchant',
        path: '/add-Merchant',
        component: AuthorizedComponent(AddMerchant, acceptAddMerchantRole),
      },
      {
        name: 'View Merchant Groups',
        path: '/view-merchant-groups',
        component: AuthorizedComponent(ViewMerchantGroups, acceptAddMerchantRole),
      }
      ,
      {
        name: 'Add Merchant Group',
        path: '/add-merchant-group',
        component: AuthorizedComponent(AddMerchantGroups, acceptAddMerchantRole),
      }
    ],
  },
  {
    name: 'Merchant Vouchers',
    path: '/merchant-vouchers',
    acceptUserRole: acceptMerchantVouchers,
    children: [
      {
        name: 'Denominations Summary',
        path: '/denominations-summary',
        component: AuthorizedComponent(
          DenominationsSummary,
          acceptMerchantVouchers
        ),
      },
      {
        name: 'Upload Denominations',
        path: '/upload-denominations',
        component: AuthorizedComponent(
          UploadDenominations,
          acceptMerchantVouchers
        ),
      },
    ],
  },
  {
    name: 'Purchases',
    path: '/purchases',
    acceptUserRole: acceptViewPurchases,
    children: [
      {
        name: 'View Purchases',
        path: '/view-Purchases',
        component: AuthorizedComponent(ViewPurchases, acceptViewPurchases),
      },
      {
        name: 'Pending Purchases',
        path: '/pending-Purchases',
        component: AuthorizedComponent(PendingPurchases, acceptViewPurchases),
      },
    ],
  },
  {
    name: 'Client',
    path: '/client',
    acceptUserRole: acceptViewVouchers,
    children: [
      {
        name: 'Place Order',
        path: '/place-order',
        component: AuthorizedComponent(
          PlaceClientOrder,
          acceptClientOrderPlace
        ),
      },
      {
        name: 'Pending Client Top Ups',
        path: '/pending-client-top-ups',
        component: AuthorizedComponent(PendingCreditTopUp, acceptAddPaymentRole),
      },
    ],
  },
  {
    name: 'Operations',
    path: '/operations',
    acceptUserRole: acceptViewPurchases,
    children: [
      {
        name: 'Deliveries & Pickups',
        path: '/deliveries-n-pickups',
        component: AuthorizedComponent(ViewOrders, acceptViewPurchases),
      },
    ],
  },
  {
    name: 'Vouchers',
    path: '/vouchers',
    acceptUserRole: acceptViewVouchers,
    children: [
      {
        name: 'View Vouchers',
        path: '/view-vouchers',
        component: AuthorizedComponent(ViewVouchers, acceptViewVouchers),
      },
    ],
  },
  {
    name: 'Themes & Products',
    path: '/themes-products',
    acceptUserRole: acceptMarketing,
    children: [
      {
        name: 'View Voucher Themes',
        path: '/view-voucher-themes',
        component: AuthorizedComponent(ViewVoucherThemes, acceptMarketing),
      },

      {
        name: 'Add Voucher Themes',
        path: '/add-voucher-themes',
        component: AuthorizedComponent(AddVoucherThemes, acceptMarketing),
      },
      {
        name: 'View Products',
        path: '/view-products',
        component: AuthorizedComponent(ViewProducts, acceptMarketing),
      },
      {
        name: 'Add Products',
        path: '/add-products',
        component: AuthorizedComponent(AddProducts, acceptMarketing),
      },
      {
        name: 'View Product Categories',
        path: '/view-product-categories',
        component: AuthorizedComponent(ViewProductCategory, acceptMarketing),
      },
      {
        name: 'Add Product Category',
        path: '/add-product-category',
        component: AuthorizedComponent(AddProductCategory, acceptMarketing),
      }
    ],
  },
  {
    name: 'Greetly',
    path: '/greetly',
    acceptUserRole: acceptMarketing,
    children: [
      {
        name: 'Greetly Vouchers',
        path: '/greetly-vouchers',
        component: AuthorizedComponent(GreetlyVouchers, acceptMarketing),
      }
    ]
  },
  {
    name: 'Client Redemptions',
    path: '/client-redemptions',
    acceptUserRole: acceptCLientInfo,
    component: AuthorizedComponent(ViewClientRedemptions, acceptCLientInfo),
  },
  {
    name: 'Merchant Summary',
    path: '/merchant-summary',
    acceptUserRole: acceptCLientInfo,
    component: AuthorizedComponent(ClientRedemptionMerchantSummary, acceptCLientInfo),
  },
  {
    name: 'Contact Us',
    path: '/contact-us',
    component: ContactUs,
  },
];

export default routes;
